import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function AboutUsPage() {
  return (
    <div className="p-0">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = usePageProvider();

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <Accordion defaultActiveKey="0" className="my-4">
            {/* SEO SECTION */}
            <Accordion.Item eventKey="0" className="w-full">
              <Accordion.Header>SEO META</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div className="flex flex-col">
                    <Label label="Meta Title" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_title" placeholder="Meta Title" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Keywords" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_keyword" placeholder="Meta Keywords" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Slug Url" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_slug_url" placeholder="Meta Slug Url" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col col-span-3">
                    <Label label="Meta Description" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_desc" placeholder="Meta Description" rootClassName="w-full" as={"textarea"} />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* HERO BANNER SECTION */}
            <Accordion.Item eventKey="1" className="w-full">
              <Accordion.Header>Hero Banner Section</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <Label label="Heading (White)" className="mb-1 " />
                        <FormikInput name="hero_banner.heading.white" placeholder="White text" />
                      </div>
                      <div>
                        <Label label="Heading (Orange)" className="mb-1 " />
                        <FormikInput name="hero_banner.heading.orange" placeholder="Orange text" />
                      </div>
                    </div>
                    <div>
                      <Label label="Sub Heading" className="mb-1 " />
                      <FormikInput name="hero_banner.subHeading" placeholder="Sub Heading" />
                    </div>
                    <div>
                      <Label label="Banner Image" className="mb-1 " />
                      <ImageUploader
                        imageUrl={values.hero_banner?.image}
                        onChange={(res) => setFieldValue("hero_banner.image", res?.data?.file_url)}
                        imgStyle={{ width: "100%", height: "200px" }}
                      />
                    </div>
                  </div>
                  <div className="space-y-4">
                    <Label label="Paragraphs" className="mb-1 " />
                    <FieldArray name="hero_banner.paragraphs">
                      {(arrayHelpers) => (
                        <div className="space-y-3">
                          {values.hero_banner?.paragraphs?.map((para, index) => (
                            <div key={index} className="flex gap-2">
                              <FormikTextarea name={`hero_banner.paragraphs.${index}`} placeholder="Paragraph text" rootClassName="flex-1" />
                              <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 self-start mt-2">
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          ))}
                          <Button type="button" variant="outline" className="!py-1 !px-4 !text-[11px]" onClick={() => arrayHelpers.push("")}>
                            + Add Paragraph
                          </Button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* WHO WE ARE (ABOUT SECTION) */}
            <Accordion.Item eventKey="2" className="w-full">
              <Accordion.Header>Who we are (About Section)</Accordion.Header>
              <Accordion.Body>
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <Label label="Heading (White)" className="mb-1 " />
                        <FormikInput name="about_section.heading.white" placeholder="White text" />
                      </div>
                      <div>
                        <Label label="Heading (Orange)" className="mb-1 " />
                        <FormikInput name="about_section.heading.orange" placeholder="Orange text" />
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label label="Main Description" className="mb-1 " />
                      <FormikTextarea name="about_section.desc" placeholder="Main description" />
                    </div>
                    <div>
                      <Label label="Secondary Description" className="mb-1 " />
                      <FormikTextarea name="about_section.sub_desc" placeholder="Secondary description" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label label="Section Right Image" className="mb-1 " />
                      <ImageUploader
                        imageUrl={values.about_section?.image}
                        imgStyle={{ width: "100%", height: "200px" }}
                        onChange={(res) => {
                          const url = res?.data?.file_url || res?.file_url || "";
                          setFieldValue("about_section.image", url);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* PRACTICALITY SECTION */}
            <Accordion.Item eventKey="3" className="w-full">
              <Accordion.Header>Practicality Section</Accordion.Header>
              <Accordion.Body>
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label label="Heading" className="mb-1 " />
                      <FormikInput name="practicality_section.heading" placeholder="Main Heading" />
                    </div>
                    <div>
                      <Label label="Heading (Orange)" className="mb-1 " />
                      <FormikInput name="practicality_section.heading_orange" placeholder="Orange text" />
                    </div>
                  </div>

                  <div>
                    <Label label="Planning Drivers / Points" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="practicality_section.drivers">
                      {(arrayHelpers) => (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {values.practicality_section?.drivers?.map((driver, index) => (
                            <div key={index} className="border border-gray-200 rounded-lg p-4 bg-gray-50/30">
                              <div className="flex justify-between mb-2">
                                <Label label={`Point #${index + 1}`} className="font-bold text-xs" />
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400">
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </div>
                              <div className="space-y-3">
                                <div>
                                  <Label label="Icon" className="text-[10px]" />
                                  <ImageUploader
                                    imageUrl={driver.icon}
                                    onChange={(res) => setFieldValue(`practicality_section.drivers.${index}.icon`, res?.data?.file_url)}
                                    imgStyle={{ width: "100%", height: "80px" }}
                                  />
                                </div>
                                <FormikInput name={`practicality_section.drivers.${index}.text`} placeholder="Driver text" />
                              </div>
                            </div>
                          ))}
                          <div className="flex items-center justify-center border-2 border-dashed border-gray-200 rounded-lg p-4">
                            <Button type="button" variant="outline" className="!py-2 !px-6" onClick={() => arrayHelpers.push({ icon: "", text: "" })}>
                              + Add Driver
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* INVESTMENT SECTION */}
            <Accordion.Item eventKey="4" className="w-full">
              <Accordion.Header>Investment Region Section</Accordion.Header>
              <Accordion.Body>
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label label="Heading" className="mb-1 " />
                      <FormikInput name="investment_section.heading" placeholder="Main Heading" />
                    </div>
                    <div>
                      <Label label="Heading (Orange)" className="mb-1 " />
                      <FormikInput name="investment_section.heading_orange" placeholder="Orange text" />
                    </div>
                  </div>
                  <div>
                    <Label label="Description" className="mb-1 " />
                    <FormikTextarea name="investment_section.description" placeholder="Section description" />
                  </div>

                  <div>
                    <Label label="Investment Benefits / Points" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="investment_section.drivers">
                      {(arrayHelpers) => (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {values.investment_section?.drivers?.map((driver, index) => (
                            <div key={index} className="border border-gray-200 rounded-lg p-4 bg-gray-50/30">
                              <div className="flex justify-between mb-2">
                                <Label label={`Benefit #${index + 1}`} className="font-bold text-xs" />
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400">
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </div>
                              <div className="space-y-3">
                                <FormikInput name={`investment_section.drivers.${index}.text`} placeholder="Benefit text" />
                              </div>
                            </div>
                          ))}
                          <div className="flex items-center justify-center border-2 border-dashed border-gray-200 rounded-lg p-4">
                            <Button type="button" variant="outline" className="!py-2 !px-6" onClick={() => arrayHelpers.push({ text: "" })}>
                              + Add Benefit
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  <div>
                    <Label label="Bottom Paragraph" className="mb-1 " />
                    <FormikTextarea name="investment_section.bottom_para_1" placeholder="Bottom paragraph" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* CONTACT SECTION */}
            <Accordion.Item eventKey="5" className="w-full">
              <Accordion.Header>Contact Section (Bottom CTA)</Accordion.Header>
              <Accordion.Body>
                <div className="space-y-4">
                  <div>
                    <Label label="Section Title" className="mb-1 " />
                    <FormikInput name="contact_section.title" placeholder="CTA Title" />
                  </div>
                  <div>
                    <Label label="Section Description" className="mb-1 " />
                    <FormikTextarea name="contact_section.description" placeholder="CTA Description" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            {/* MAP SECTION */}
            <Accordion.Item eventKey="6" className="w-full">
              <Accordion.Header>Map Section</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <Label label="Title" className="mb-1 " />
                    <FormikInput name="map.title" placeholder="Title" />
                  </div>
                  <div>
                    <Label label="Highlight" className="mb-1 " />
                    <FormikInput name="map.highlight" placeholder="Highlight" />
                  </div>
                  <div>
                    <Label label="Sub Title" className="mb-1 " />
                    <FormikInput name="map.sub_title" placeholder="Sub Title" />
                  </div>
                  <div className="sm:col-span-2 lg:col-span-3">
                    <Label label="Map URL (iFrame URL)" className="mb-1 " />
                    <FormikInput name="map.url" placeholder="Paste Google Maps iframe src URL here" />
                  </div>
                  {values.map?.url && (
                    <div className="mt-4 sm:col-span-2 lg:col-span-3">
                      <Label label="Map Preview" className="mb-2 text-xs font-bold text-gray-400 uppercase" />
                      <div className="rounded-xl overflow-hidden border border-gray-200 h-[300px] shadow-inner bg-gray-50">
                        <iframe
                          src={values.map.url}
                          className="w-full h-full border-0"
                          title="Map Preview"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7" className="w-full">
              <Accordion.Header>{"Footer Banner Image"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 mb-6">
                  <Label label="Footer Banner Image" className="mb-1" />
                  <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                    title="Footer Banner Image"
                    imageUrl={values.footer_bgimg}
                    onChange={(res) => setFieldValue("footer_bgimg", res?.data?.file_url)}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* FIXED BOTTOM SAVE BAR */}
          <div className="save-button-bar !bg-white/95 !backdrop-blur-md">
            <Button
              type="submit"
              label="SAVE CHANGES"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
